import createClient, {} from 'openapi-fetch';
export function createApiClient(opts) {
    const headers = {
        'X-Requested-With': 'leanin-spa',
    };
    if (opts.correlationId !== undefined) {
        headers['X-Correlation-Id'] = opts.correlationId;
    }
    if (opts.cookie !== undefined && opts.cookie.length > 0) {
        headers['Cookie'] = opts.cookie;
    }
    if (opts.headers !== undefined) {
        for (const [k, v] of Object.entries(opts.headers)) {
            headers[k] = v;
        }
    }
    const clientOpts = {
        baseUrl: opts.baseUrl,
        credentials: 'include',
        headers,
        ...(opts.fetch !== undefined ? { fetch: opts.fetch } : {}),
    };
    return createClient(clientOpts);
}
//# sourceMappingURL=client.js.map